import { FormikErrors, FormikTouched, FormikValues } from 'formik';
import isEmpty from 'lodash/isEmpty';

/**
 * Проверяет неактивное состояние кнопки отправки данных формы.
 *
 * @param {object} errors - объект, содержащий сообщения об ошибках.
 * @param {object} touched - объект, содержащий состояние касания формы.
 * @returns {boolean} Возвращает true, если поля формы заполнены некорректно, иначе false.
 */
const isDisabled = (errors: FormikErrors<FormikValues>, touched: FormikTouched<FormikValues>) =>
  !(isEmpty(errors) && !isEmpty(touched));

export default isDisabled;
